export type TwoN4uAdRuntimeEnvironment = 'dev' | 'dr' | 'prod'

export interface TwoN4uAdRuntime {
  environment: TwoN4uAdRuntimeEnvironment
  sdkUrl: string
}

const DR_SDK_URL = 'https://ad-dr.2n4u.co.kr/sdk/v2/2n4u-ads.js'
const PROD_SDK_URL = 'https://ad.2n4u.co.kr/sdk/v2/2n4u-ads.js'

/**
 * 2n4uAd v0.3.1 first-party apps always use the app origin for ad requests.
 * Nginx routes only these exact paths to 2n4uAd, where the App Registry
 * resolves the authoritative app identity from the trusted vhost.
 */
export const TWO_N4U_AD_TRANSPORT = {
  requestEndpoint: '/api/ad/v2/request',
  batchEndpoint: '/api/ad/v2/batch',
} as const

const PROD_HOSTS = new Set([
  'segno.2n4u.co.kr',
  'www.miosegno.com',
])

/**
 * Resolve the ad runtime from the page hostname instead of baking a DR/PROD
 * endpoint into the Vite artifact.
 *
 * This permits the exact same frontend artifact that passes edenWeb DR to be
 * promoted later to 3digmWeb. Known production hostnames use production ads;
 * every other production-mode hostname fails safely toward the DR provider.
 */
export function resolveTwoN4uAdRuntime(
  hostname: string,
  isDevelopmentBuild: boolean,
): TwoN4uAdRuntime {
  if (isDevelopmentBuild) {
    return { environment: 'dev', sdkUrl: DR_SDK_URL }
  }

  const normalizedHost = hostname.trim().toLowerCase().replace(/\.$/, '')
  if (PROD_HOSTS.has(normalizedHost)) {
    return { environment: 'prod', sdkUrl: PROD_SDK_URL }
  }

  return { environment: 'dr', sdkUrl: DR_SDK_URL }
}
